<template>
	<div class="gift-body">
		<div style="width:100%;flex:1;display:flex;flex-direction: column;overflow-y:auto">
			<div class="order-menu">
				<span>
					<i class="el-icon-back" @click="goBack"></i>
				</span>{{isAdd ? '新建附属商品':'编辑附属商品'}}
			</div>
			<div style="width:100%;flex:1;display:flex;flex-direction: column;overflow-y:auto">
					<div class="gift-row">
							<div class="gift-row-title">
								适用门店：
							</div>
							<div class="gift-row-content" style="width:400px">
								<el-radio style="min-height: 40px;;line-height: 40px;" :disabled="isDisable" v-model="allShopFlag" :label="1">全部门店</el-radio>
								<el-radio style="min-height: 40px;;line-height: 40px;" :disabled="isDisable" v-model="allShopFlag" :label="0">自定义门店</el-radio>
								<div  v-if="allShopFlag === 0 && !isDisable" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
									<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
									选择门店
								</div>
							</div>
						</div>
						<div v-if="allShopFlag === 0" class="customer-box">
							<span style="font-size: 13px;">已选：</span>
							{{shopText}}
						</div>
						<div class="gift-row">
							<div class="gift-row-title">
								适用客户：
							</div>
							<div class="gift-row-content" style="width:400px">
								<el-radio v-model="allCustomerFlag" :label="1" :disabled="isDisable">全部</el-radio>
								<el-radio v-model="allCustomerFlag" :label="0" :disabled="isDisable">自定义</el-radio>
								<span v-if="allCustomerFlag === 0 && !isDisable" @click="addCusClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
									<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
									选择客户
								</span>
							</div>
						</div>
						<div v-if="allCustomerFlag === 0" class="customer-box">
							<span style="font-size: 13px;">已选：</span>
							{{cusText}}
						</div>
						<div class="gift-row">
							<div class="gift-row-title">
								生效条件：
							</div>
							<div class="gift-row-content" style="width:400px">
								<el-radio v-model="type" :label="0" :disabled="isDisable">订单足额</el-radio>
								<el-radio v-model="type" :label="1" :disabled="isDisable">下单主商品</el-radio>
							</div>
						</div>
						<div v-if="type === 1">
							<div class="fx-title">
								<span>主商品</span>
							</div>
							<div class="main-product-box">
								<div class="main-product-title">
									<div class="left">主商品</div>
									<div class="right">操作</div>
								</div>
								<div class="main-product-row">
									<div class="left">
										<span v-if="mainProduct === null && !isDisable" @click="addMainproduct" style="color: var(--fx-primary-color);cursor: pointer;">+添加主商品</span>
										<div v-if="mainProduct !== null && !isDisable">
											<div class="product-top">
												{{mainProduct.productname}}
											</div>
											<div class="product-bottom">
												{{mainProduct.productcode}}
											</div>
										</div>
									</div>
									<div class="right" v-if="!isDisable">
										<div v-if="mainProduct === null" ></div>
										<div v-else>
											<el-button type="text" size="mini" @click='addMainproduct'>更换</el-button>
											<el-button type="text" size="mini" @click='delMainProduct'>删除</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="type === 0">
							<div class="rule-box">
								规则：订单金额大于等于
								<el-input style="width: 150px;margin:0 10px" size="mini" :disabled="isDisable" @change="orderMoneyRuleChange" v-model="orderMoneyRule"></el-input>
								元
								<el-select style="width: 150px;margin:0 10px" v-model="freightFlag" size='mini' disabled>
									<el-option :value="0" label="不含运费"></el-option>
									<el-option :value="1" label="含运费"></el-option>
								</el-select>
							</div>
						</div>
						<div class="fx-title">
							<span>附属商品</span>
							<span style="margin-left:10px;color:#999999;font-size: 12px;">最多可添加49个附属商品</span>
						</div>
						<div class="gift-product-box">
							<div class="gift-product-title">
								<div class="title-box">附属商品</div>
								<div class="title-box">规格</div>
								<div class="title-box1" style="width: 80px;">是否可见</div>
								<div v-if="type === 1"  class="title-box">附属方式</div>
								<div v-if="type === 1"  class="title-box" style="min-width: 240px;">数量值/比例</div>
								<div v-if="type === 0"  class="title-box">附属商品数</div>
								<div class="title-box1" style="min-width: 120px;">是否向上取整
									<el-tooltip effect="dark" placement="top" popper-class="tip-class">
										<div slot="content">
											向上取整开启后当主商品数量大于<br/>当前比例但不超过下一比例时，副<br/>商品取下一比例数量
										</div>
										<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
									</el-tooltip>
								</div>
								<div class="title-box1" style="min-width: 80px;">是否为赠品</div>
								<div style="width: 100px;" v-if="!isDisable">操作</div>
							</div>
							<div class="gift-product-container">
								<div v-for="item in appendList" :key='item.attrplanid' class="gift-product-row">
									<div class="gift-box-name">
										<div class="product-top" style="flex-direction: row;display: flex;align-items: center;">
											<div style="display: flex;align-items: center;justify-content: center;color: #FFFFFF; width: 18px;height: 18px;font-size: 12px;colro:#fff;background-color: #44BB60;border-radius: 2px;margin-right: 5px;" v-if="item.giftFlag ===1">赠</div>
											{{item.productname}}
										</div>
										<div class="product-bottom">
											{{item.productcode}}
										</div>
									</div>
									<div class="gift-box-name">
										<div class="product-top">
											{{item.spec}}
										</div>
										<div class="product-bottom">
											{{item.code}}
										</div>
									</div>
									<div class="gift-box1" style="width: 80px;">{{item.visibleflag ? '可见' : '不可见'}}</div>
									<div v-if="type === 1" class="gift-box">
										<el-select v-model="item.appendageType" @change="appendageTypeChange(item)" size="mini">
											<el-option :value="1" label="按比例" :disabled="isDisable"></el-option>
											<el-option :value="2" label="固定值" :disabled="isDisable"></el-option>
										</el-select>
									</div>
									<div v-if="type === 1" class="gift-box" style="min-width: 240px;">
										<el-input :disabled="isDisable" v-if="item.appendageType === 2" style="width: 100px;" @change="checkAppend(item)" v-model='item.appendageQuantity' size="mini"></el-input>
										<div v-else style="display: flex;align-items: center;flex-direction: row;">
											主商品：附属商品=
											<el-input :disabled="isDisable" style="width: 60px;" @change="mainQuantityChange(item)" v-model='item.mainQuantity' size="mini"></el-input>
											:
											<el-input :disabled="isDisable" style="width: 60px;" @change="appendageQuantityChange(item)" v-model='item.appendageQuantity' size="mini"></el-input>
										</div>
									</div>
									<div v-if="type === 0"  class="gift-box">
										<el-input :disabled="isDisable" v-model='item.appendageQuantity' @change="checkAppend(item)" style="width: 100px;" size="mini"></el-input>
									</div>
									<div class="gift-box1" style="min-width: 120px;">
										<el-switch
											:disabled="isDisable"
											v-model="item.roundUpFlag"
											active-color="#13ce66"
											inactive-color="#ff4949"
											:active-value="1"
											:inactive-value="0">
										</el-switch>
									</div>
									<div class="gift-box1" style="min-width: 80px;">
										<el-switch
											:disabled="isDisable"
											v-model="item.giftFlag"
											active-color="#13ce66"
											inactive-color="#ff4949"
											:active-value="1"
											:inactive-value="0">
										</el-switch>
									</div>
									<div style="width: 100px;" v-if="!isDisable">
										<el-button type="text" size="mini" @click='delAppendage(item)'>删除</el-button>
									</div>
								</div>
							</div>
						</div>
			</div>
			<div style="height: 40px;display: flex;align-items: center;flex-direction: row;" v-if="!isDisable">
				<div style="color: var(--fx-primary-color);flex:1;text-align: left;">
					<span @click="addAppendage" style="cursor: pointer;">
						+添加附属品
					</span>
				</div>
				<div style="flex:1;text-align: left;">
					<el-button size="mini" type="primary" @click='saveAppendClick'>保存</el-button>
				</div>

			</div>
		</div>
		<el-dialog
			title="选择客户"
			:visible.sync="customerDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<bind-customer v-if="customerDialog" :customerDialog.sync="customerDialog" @reloadCus='reloadCus' :customertype='customertype' :chooseCusByCate='chooseCusByCate' :chooseCusBylevel='chooseCusBylevel'></bind-customer>
			</div>
		</el-dialog>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="30%">
			<div style="width: 100%;max-height: 300px;overflow-y:auto ;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					【{{item.customername}}】在【{{item.name}}】的买赠活动中已绑定关系！
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showError = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			:title="isGift ? '选择附属品' : '选择主商品'"
			class="dialog-title"
			:visible.sync="appendDialog"
			width="1200px"
			append-to-body
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>商品类别：</span>
						<el-select filterable v-model="typeCategory" class="filter-input" size='mini'>
							<el-option value="0" label="全部"></el-option>
							<el-option :value="item.id" :label="item.name" v-for="item in categoryList" :key="item.id"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<span>启用状态：</span>
						<el-select v-model="disabledflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='0' label="启用"></el-option>
							<el-option :value='1' label="停用"></el-option>
						</el-select>
					</div>
					<div v-if="isGift === 1" class="input-box">
						<span>可售状态：</span>
						<el-select v-model="planDisabledflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='0' label="可售"></el-option>
							<el-option :value='1' label="停售"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<span>可见状态：</span>
						<el-select v-model="visibleFlag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='true' label="可见"></el-option>
							<el-option :value='false' label="不可见"></el-option>
						</el-select>
					</div>
					<div style="width: 200px;">
						<el-input
							v-model="keyword"
							size="mini"
							@keyup.enter.native="search">
						</el-input>
					</div>
					<el-button size="small" type="primary" class="btn fx-btn" @click="searchClick">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clearSearch">清空</el-button>
				</div>
				<el-table
					class="grid-content"
					:data="productTableData"
					border
					size='mini'
					height="400"
					ref="table"
					@selection-change='handleSelectionChange'
				>
					<el-table-column
						key='checkbox'
						v-if="isGift === 1"
						type="selection"
						align="center"
						width="40">
					</el-table-column>
					<el-table-column
						width="40"
						key='radio'
						v-if="isGift === 0"
						align="center">
						<template slot-scope='scope'>
							<el-radio v-model="chooseId" class='radioClass' @change='radioChange(scope.row)' :label='scope.row.productid'></el-radio>
						</template>
					</el-table-column>
					<el-table-column
						key='typeCategory'
						prop="typeCategory"
						label="商品类别"
						align="center">
					</el-table-column>
					<el-table-column
						key="productname"
						prop="productname"
						label="商品名称"
						align="center">
					</el-table-column>
					<el-table-column
						v-if="isGift === 1"
						key="spec"
						prop="spec"
						label="规格名称"
						align="center">
					</el-table-column>
					<el-table-column
						key="productcode"
						prop="productcode"
						label="SPU编号"
						align="center">
					</el-table-column>
					<el-table-column
						v-if="isGift === 1"
						key="planDisabledflag"
						prop="planDisabledflag"
						label="可售状态"
						align="center">
						<template slot-scope='scope'>
							<div class="point-box">
								<div v-if="!scope.row.planDisabledflag" class='point' style="background-color:#60C769"></div>
								<div v-if="scope.row.planDisabledflag" class='point' style="background-color:#ED4F31"></div>
								<span>{{scope.row.planDisabledflag ? '停售' : '可售'}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						key="visibleflag"
						prop="visibleflag"
						label="可见状态"
						align="center">
						<template template slot="header">
							<div>可见状态
								<el-tooltip class="item" effect="dark" content="*可见状态是控制该商品在可以销售的情况下，买家在小程序中无法主动进行检索、下单等，但是可以通过作为附属品，赠品提单" placement="top">
									<i class="el-icon-warning-outline" style="color: var(--fx-primary-color);"></i>
								</el-tooltip>
							</div>
						</template>
						<template slot-scope='scope'>
							<div class="point-box">
								<span>{{scope.row.visibleflag ? '可见' : '不可见'}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						key="disabledflag"
						prop="disabledflag"
						label="启用状态"
						align="center">
						<template slot-scope='scope'>
							<div class="point-box">
								<div v-if="!scope.row.disabledflag" class='point' style="background-color:#60C769"></div>
								<div v-if="scope.row.disabledflag" class='point' style="background-color:#ED4F31"></div>
								<span>{{scope.row.disabledflag ? '已停用' : '已启用'}}</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div style="display: flex;align-items: center;justify-content: space-between;height: 40px;">
					<div>
						<span v-if="isGift === 1">
							已选：{{this.chooseGift.length}}
						</span>
					</div>
					<el-pagination
						style="margin: 10px; text-align: center;"
						@size-change="productSizeChange"
						@current-change="productPageChange"
						:current-page="productPagination.page"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="productPagination.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="productTotalCount">
					</el-pagination>
				</div>

				<div class="valet-foot">
					<el-button plain type="primary" size='small' @click='cancelClick'>取消</el-button>
					<el-button v-if="isGift === 0" plain type="primary" size='small' @click='addproductClick'>添加</el-button>
					<el-button v-if="isGift === 1" plain type="primary" size='small' @click='addgiftClick'>添加</el-button>
				</div>
			</div>

		</el-dialog>
	</div>
</template>
<script>
import BindCustomer from '@/components/appendageDetail/bindCustomer.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'gift',
	components: {
		BindCustomer,
		bindShop
	},
	data () {
		return {
			id: '',
			attrplanIds: [],
			productIds: [],
			appendList: [],
			selectMainProduct: null,
			mainProduct: null,
			chooseId: '',
			categoryList: [],
			chooseGift: [],
			giftList: [],
			productTotalCount: 0,
			productPagination: {
				page: 1,
				size: 20
			},
			AuthorityList: {
				'02_0004_0001_00': false,
				'02_0004_0002_00': false,
				'02_0004_0003_00': false,
				'02_0004_0004_00': false
			},
			productTableData: [],
			isGift: 0,
			appendDialog: false,
			keyword: '',
			visibleFlag: -1,
			planDisabledflag: -1,
			disabledflag: -1,
			typeCategory: '0',
			freightFlag: 0,
			orderMoneyRule: 0,
			type: 0,
			isAdd: true,
			cusText: '',
			code: '',
			allCustomerFlag: 1,
			chooseData: null,
			customerDialog: false,
			chooseCusByCate: [],
			chooseCusBylevel: [],
			chooseCus: [],
			customertype: 0,
			allShopFlag: 1,
			shopDialog: false,
			shopText: '',
			chooseShop: [],
			errorList: [],
			oldCus: '',
			showError: false,
			orderNumberRoundRules: null,
			orderdecimalcount: null,
			isDisable: false
		}
	},
	created () {
		this.getCategoryList()
		this.getSystemSetting()
		let id = window.sessionStorage.getItem('appendageId')
		if (id) {
			this.isAdd = false
			this.getDetail(id)
		} else {
			this.isAdd = true
		}
		this.getAuthority('02_0004_0000_00')
	},
	methods: {
		getDetail (id) {
			let params = {
				id: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/appendage/findAppendageDetail`,
				data: params
			}).then(res => {
				if (!res.result) {
					this.$message.error(res.msg)
					return false
				}
				let data = res.data
				this.id = data.id
				this.type = data.type
				if (this.type === 1) {
					this.mainProduct = {
						productname: data.mainProductName,
						productcode: data.mainProductCode,
						productid: data.mainProductId
					}
				}
				this.orderMoneyRule = data.orderMoneyRule
				this.freightFlag = data.freightFlag
				this.allShopFlag = data.allShopFlag
				this.allCustomerFlag = data.allCustomerFlag
				this.customertype = data.customerType
				this.appendList = data.detail
				let cusList = data.customerList
				cusList.forEach(item => {
					item.name = this.customertype === 0 ? item.categoryname : item.levelname
					item.id = this.customertype === 0 ? item.categoryid : item.levelid
					item.showCus = 1
				})
				cusList = JSON.parse(JSON.stringify(cusList))
				this.chooseCus = cusList
				this.oldCus = JSON.stringify(cusList)
				if (this.customertype === 0) {
					this.chooseCusBylevel = []
					this.chooseCusByCate = cusList
				} else {
					this.chooseCusBylevel = cusList
					this.chooseCusByCate = []
				}
				this.initCusData()
				this.initShopData(data.shops)
			})
		},
		orderMoneyRuleChange () {
			this.orderMoneyRule = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(this.orderMoneyRule, 2) : this.toFix(this.orderMoneyRule)
			if (this.orderMoneyRule > 999999.99) {
				this.orderMoneyRule = 999999.99
			}
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			num = num.substring(0, num.indexOf('.') + 3)
			return num
		},
		appendageTypeChange (row) {
			row.mainQuantity = 1
			row.appendageQuantity = 1
		},
		mainQuantityChange (row) {
			if (row.mainQuantity === '') {
				row.mainQuantity = 1
			}
			row.mainQuantity = row.mainQuantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.mainQuantity = row.mainQuantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.mainQuantity = row.mainQuantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.mainQuantity = row.mainQuantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			row.mainQuantity = row.mainQuantity.replace(/[^0-9]/g, '')// 只能输入数字
			row.mainQuantity = row.mainQuantity > 99 ? 99 : row.mainQuantity
			row.mainQuantity = row.mainQuantity < 1 ? 1 : row.mainQuantity
		},
		appendageQuantityChange (row) {
			if (row.appendageQuantity === '') {
				row.appendageQuantity = 1
			}
			row.appendageQuantity = row.appendageQuantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.appendageQuantity = row.appendageQuantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.appendageQuantity = row.appendageQuantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.appendageQuantity = row.appendageQuantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			row.appendageQuantity = row.appendageQuantity.replace(/[^0-9]/g, '')// 只能输入数字
			row.appendageQuantity = row.appendageQuantity > 99 ? 99 : row.appendageQuantity
			row.appendageQuantity = row.appendageQuantity < 1 ? 1 : row.appendageQuantity
		},
		getSystemSetting () {
			var params = {
				orderid: this.orderid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderSystemSetting`,
				data: params
			}).then(res => {
				this.orderNumberRoundRules = res.data.ordermoneyroundrules
				this.orderdecimalcount = res.data.orderdecimalcount
			})
		},
		checkAppend (row) {
			if (row.appendageQuantity === '') {
				row.appendageQuantity = 1
			}
			row.appendageQuantity = row.appendageQuantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.appendageQuantity = row.appendageQuantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.appendageQuantity = row.appendageQuantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.appendageQuantity = row.appendageQuantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.orderdecimalcount) {
			case 0:
				row.appendageQuantity = row.appendageQuantity.replace(/[^0-9]/g, '')// 只能输入数字
				break
			case 1:
				row.appendageQuantity = row.appendageQuantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.appendageQuantity = row.appendageQuantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.appendageQuantity = row.appendageQuantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.appendageQuantity = row.appendageQuantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		saveAppendClick () {
			if (this.type === 1 && this.mainProduct === null) {
				this.$message.error('请选择主商品')
				return false
			}
			if (this.appendList.length === 0) {
				this.$message.error('请选择附属品')
				return false
			}
			let newCus = this.chooseCus
			let params = {
				id: this.id,
				type: this.type,
				orderMoneyRule: this.orderMoneyRule,
				freightFlag: this.freightFlag,
				allShopFlag: this.allShopFlag,
				allCustomerFlag: this.allCustomerFlag,
				shopIds: this.chooseShop,
				customerType: this.customertype,
				details: this.appendList,
				productId: this.mainProduct ? this.mainProduct.productid : '',
				productName: this.mainProduct ? this.mainProduct.productname : ''
			}
			if (this.oldCus !== JSON.stringify(newCus)) {
				params.customerDetail = this.chooseCus
			}
			let logger = null
			if (this.isAdd) {
				logger = this.$fxLogger.createInfo('goods.appendage-goods.add', { text: this.createLoggerParams() })
			} else {
				logger = this.$fxLogger.createInfo('goods.appendage-goods.update', { text: this.createLoggerParams() })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/appendage/saveAppendage`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					window.sessionStorage.setItem('appendageId', res.data.id)
					this.getDetail(res.data.id)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			let result
			let text1 = `适用门店：${this.allShopFlag === 1 ? '全部门店' : this.shopText}`
			let text2 = `适用客户：${this.allCustomerFlag === 1 ? '全部客户' : this.cusText}`
			let text3 = `生效条件：${this.type === 0 ? `订单金额大于等于${this.orderMoneyRule}元` : `下单主商品:${this.mainProduct.productname}`}`
			let textArr = []
			let text = ''
			this.appendList.forEach(item => {
				text = `【${item.productname}】,附属方式：${item.appendageType === 1 ? '按比例' : '固定值'},数值/比例：${item.mainQuantity}：${item.appendageQuantity},是否向上取整：${item.roundUpFlag === 1 ? '是' : '否'},是否为赠品：${item.giftFlag === 1 ? '是' : '否'}`
				textArr.push(text)
			})
			textArr.join(';')
			result = text1 + ',' + text2 + ',' + text3 + ',附属商品：' + textArr
			console.log(result)
			return result
		},
		delAppendage (data) {
			let list = []
			this.appendList.forEach(item => {
				if (data.attrplanid !== item.attrplanid) {
					list.push(item)
				}
			})
			this.appendList = list
		},
		delMainProduct () {
			this.mainProduct = null
		},
		radioChange (data) {
			this.selectMainProduct = data
		},
		getCategoryList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`
			}).then(res => {
				this.categoryList = res.data
			})
		},
		searchClick () {
			let url = ''
			let params = {
				id: this.mainProduct ? this.mainProduct.productid : '',
				typeCategory: this.typeCategory,
				disabledflag: this.disabledflag,
				keyword: this.keyword,
				page: this.productPagination.page,
				size: this.productPagination.size
			}
			if (this.visibleFlag !== -1) {
				params.visibleFlag = this.visibleFlag
			}
			if (this.isGift) {
				params.planDisabledflag = this.planDisabledflag
				params.attrplanIds = this.attrplanIds
				url = 'appendage/productattrplanlist'
			} else {
				params.productIds = this.productIds
				url = 'appendage/mainproductlist'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/` + url,
				data: params
			}).then(res => {
				this.productTableData = res.recordList
				this.productTotalCount = res.recordCount
			})
		},
		clearSearch () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.visibleFlag = -1
			this.keyword = ''
			this.planDisabledflag = -1
			this.disabledflag = -1
			this.typeCategory = '0'
			this.searchClick()
		},
		addproductClick () {
			this.mainProduct = this.selectMainProduct
			this.appendDialog = false
		},
		addgiftClick () {
			let list = this.chooseGift
			list.forEach(item => {
				item.appendageType = 1
				item.mainQuantity = 1
				item.appendageQuantity = 1
				item.giftFlag = 0
			})
			this.appendList = this.appendList.concat(JSON.parse(JSON.stringify(list)))
			this.appendDialog = false
		},
		handleSelectionChange (val) {
			this.chooseGift = val
		},
		productSizeChange (val) {
			this.productPagination.size = val
			this.searchClick()
		},
		productPageChange (val) {
			this.productPagination.page = val
			this.searchClick()
		},
		addAppendage () {
			this.isGift = 1
			this.attrplanIds = this.appendList.map(item => {
				return item.attrplanid
			})
			this.appendDialog = true
			this.clearSearch()
		},
		addMainproduct () {
			this.isGift = 0
			this.chooseId = ''
			this.productIds = this.appendList.map(item => {
				return item.productid
			})
			this.appendDialog = true
			this.clearSearch()
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let id = window.sessionStorage.getItem('appendageId')
					if (id) {
						this.isDisable = !this.AuthorityList['02_0004_0002_00']
					} else {
						this.isDisable = !this.AuthorityList['02_0004_0003_00']
					}
				}
			})
		},
		reloadCus (data) {
			this.chooseCus = data.chooseData
			this.customertype = data.customertype
			if (this.customertype === 0) {
				this.chooseCusByCate = this.chooseCus
			} else {
				this.chooseCusBylevel = this.chooseCus
			}
			this.initCusData()
			this.customerDialog = false
		},
		checkCusNum (data) {
			let num = 0
			data.forEach(item => {
				if (item.id !== '-1') {
					num++
				}
			})
			return num
		},
		initCusData () {
			let textArr = []
			let list = this.chooseCus
			list.forEach(item => {
				let itemText = ''
				if (item.categoryOrLevelFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				textArr.push(itemText)
			})
			this.cusText = textArr.join('，')
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
		},
		addCusClick () {
			this.customerDialog = true
		},
		cancelClick () {
			this.appendDialog = false
		},
		goBack () {
			this.$router.push('appendageList')
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		}
	}
}
</script>
<style lang="stylus" scoped>

.gift-body{
	font-family: Microsoft YaHei;
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow :hidden;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			i {
				border-radius 50%
				text-align: center;
				background: #9da6af;
				padding: 3px;
				cursor pointer
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.tip-icon {
		margin-left: 5px;
		cursor: pointer
	}
	.customer-box{
		line-height 40px;
		padding-left :41px;
		padding-right :20px;
		text-align :left;
		box-sizing :border-box;
	}
	.gift-row{
		min-height :40px;
		display :flex;
		flex-direction :row;
		align-items :center;
		.gift-row-title{
			width :80px;
			height :40px;
			display :flex;
			align-items :center;
			font-size :13px;
			justify-content: flex-end;
		}
		.gift-row-content{
			width :200px;
			height:40px;
			display :flex;
			align-items :center;
			text-align :left
		}
		.condition-des {
			color:#EE4F31;
			text-align:left;
			margin-bottom: 5px
		}
	}
	.rule-box{
		padding-left :44px;
		height: 40px;
		display:flex;
		align-items :center
	}
	.main-product-box{
		width:600px;
		.main-product-title{
			width:100%;
			height:36px;
			background-color:#F7F8FA;
			padding:0 10px;
			box-sizing :border-box
			display:flex;
			align-items:center;
			font-size:12px;
			font-weight:400;
			color:#333333;
		}
		.left{
			display :flex
			flex:2;
			align-items: center
		}
		.right{
			display :flex
			flex:1;
			padding-left :20px;
			align-items: center
		}
		.main-product-row{
			min-height :50px;
			box-sizing :border-box
			display:flex;
			padding :0 10px;
			flex-direction :row;
			border-bottom :1px solid #F7F8FA;
		}
	}
	.gift-product-container{
			display :flex;
			flex-direction :column;
			flex :1;
		}
	.gift-product-row{
		min-height :50px;
		box-sizing :border-box
		display:flex;
		padding :0 10px;
		align-items :center;
		flex-direction :row;
		border-bottom :1px solid #F7F8FA;
	}
	.product-top{
		text-align :left;
		color:#333333
	}
	.product-bottom{
		text-align :left;
		color:#999999
	}
	.gift-product-box{
		width :100%;
		flex-direction :column;
		.gift-product-title{
			width:100%;
			height:36px;
			background-color:#F7F8FA;
			padding:0 10px;
			box-sizing :border-box
			display:flex;
			align-items:center;
			font-size:12px;
			font-weight:400;
			color:#333333;
			.title-box1{
				display :flex;
				align-items :center
			}
			.title-box{
				flex:1
				display :flex;
				align-items :center
			}
		}
		.gift-box-name{
			flex:1
			display :flex;
			flex-direction :column
		}
		.gift-box1{
			display :flex;
			align-items :center
		}
		.gift-box{
			flex:1
			display :flex;
			align-items :center
		}
	}
}
.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.filter-input{
			width: 120px
		}
	}
	.valet-foot{
		height :40px;
		display :flex;
		align-items center;
		justify-content :center
	}
</style>
<style lang="stylus">
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
.gift-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
	.cell{
		padding :0px !important
	}
}
</style>
